var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPath5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.6022C0 11.8557 1.18783 9.91399 3.70732 6.91242C3.97365 6.59385 4.25329 6.2672 4.6155 5.84447C7.41463 2.58906 8.10443 1.71731 8.62377 0.557332C8.6982 0.393112 8.83887 0.250879 9.02581 0.15084C9.21275 0.0507999 9.43645 -0.00195978 9.66512 5.56652e-05C9.89379 0.00207111 10.1158 0.0587592 10.2996 0.162067C10.4835 0.265374 10.6198 0.410048 10.6892 0.575535C11.1686 1.72641 11.8277 2.59209 14.5669 5.88695C14.9358 6.32889 15.2181 6.67274 15.4884 7.00647C17.8668 9.94433 19 11.8739 19 13.6033C19.0033 15.5149 18.0316 17.3531 16.2886 18.7323C14.5456 20.1114 12.1669 20.9242 9.6518 21C7.10616 20.9297 4.69132 20.1258 2.89839 18.7516C1.10547 17.3773 0.0690789 15.5361 0 13.6022H0Z",
    fill: "#6D7278"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath5);
export default __webpack_public_path__ + "static/media/path5.ba0fe9c51cdd9858ea6af5b561c20d4b.svg";
export { ForwardRef as ReactComponent };